import axios from "axios";
import axiosUtil from "@plannel/utils/axios-bigint"

const getTenant = (tenant) => {
  return `${tenant}-tenant-id`;
};

const signup = (user) => {
  return axios.post("/api/auth/signup", user, 
  { 
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": getTenant(user.tenant)
    },
    transformResponse: axiosUtil.transformResponse,
    transformRequest: axiosUtil.transformRequest
  });
};

const login = async (tenant, username, password, passedMfa = false) => {
  const response = await axios.post("/api/auth/signin", {
    username, password, passedMfa
  }, {
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": getTenant(tenant)
    },
    transformResponse: axiosUtil.transformResponse
  });
  if (response.data.accessToken) {
    localStorage.setItem("user", axiosUtil.jsonbigStringfy(response.data));
    setGuideCookies(response.data.accessToken, getTenant(tenant));
  }
  return response.data;
};

// /guide(사용자 가이드) 접근용 쿠키 — 브라우저 직접 탐색은 Authorization 헤더를 보낼 수 없어,
// 서버(AuthTokenFilter)가 GET /guide/** 에 한해 이 쿠키로 로그인 여부를 확인한다.
const setGuideCookies = (accessToken, tenantId) => {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `plannel-guide-token=${accessToken}; path=/guide; SameSite=Lax${secure}`;
  document.cookie = `plannel-guide-tenant=${tenantId}; path=/guide; SameSite=Lax${secure}`;
};

const clearGuideCookies = () => {
  document.cookie = "plannel-guide-token=; path=/guide; Max-Age=0";
  document.cookie = "plannel-guide-tenant=; path=/guide; Max-Age=0";
};

const logout = () => {
  localStorage.removeItem("user");
  clearGuideCookies();
};

const getCurrentUser = () => {
  return axiosUtil.jsonbigParse(localStorage.getItem("user"));
};

const authService = {
  signup,
  login,
  logout,
  getCurrentUser,
  getTenant
};

export default authService;